import { colors } from '../../colors';
var card = {
  textColorDark: colors.graphite,
  textColorLight: colors.white,
  bgColor: colors.white,
  bgColorHero: colors.white
};
export default card;